import styled, { Keyframes } from 'styled-components';
import { styleSheet } from '../../assets/styles/global';
import { keyframes } from 'styled-components';

interface ModuloTopProps {
  color: string;
}

interface ModuleProps {
  isAddModule?: boolean;
}

export const Container = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

export const MainBody = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow-y: hidden;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 12px;     
  }

  ::-webkit-scrollbar-track {
    background: #EEEEEE;    
    border-radius: 20px;       
  }

  ::-webkit-scrollbar-thumb {
    background-color: #CCCCCC;    
    border-radius: 20px;       
    border: 3px solid #EEEEEE;  
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  padding: 31px 65px;
`;

export const TitleIcon = styled.img`
  width: 25px;
  height: 30px;
`;

export const TitleText = styled.h2`
  font-size: 2rem;
  color: ${styleSheet.colorMainDark};

  margin: 0px;
  margin-left: 15px;
`;

export const Divider = styled.div`
  width: 70%;
  display: block;
  border-bottom: 1px solid #CECECE;

  margin: 0 auto;
`;

export const ProductBody = styled.div`
  width: 100%;
  /* height: 650px; */
  /* display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start; */
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: auto;

  padding: 40px 36px;

  /* overflow-y: auto; */

  ::-webkit-scrollbar {
    width: 12px;     
  }

  ::-webkit-scrollbar-track {
    background: #EEEEEE;    
    border-radius: 20px;       

  }

  ::-webkit-scrollbar-thumb {
    background-color: #CCCCCC;    
    border-radius: 20px;       
    border: 3px solid #EEEEEE;  
  }
`;

export const Modulo = styled.div<ModuleProps>`
  width: 100%;
  height: ${({ isAddModule }) => isAddModule ? '115px' : 'auto'};
  background-color: #eeeeee;
  border-radius: 10px;
  flex: 1;

  display:block;

  margin: 0 1.5%;
  /* margin-top: 30px; */
`;

export const ModuloTop = styled.div<ModuloTopProps>`
  width: 100%;
  height: 20px;
  background-color: ${({ color }) => color};
  border-radius: 10px 10px 0px 0px;
`;

export const ModuloBody = styled.div`
  width: 100%;

  padding: 15px;
`;

export const ModuloHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 26px;
`;

export const ModuloTitle = styled.h2`
  font-size: 2rem;
  font-weight: 600;
`;

export const ButtonDeleteModulo = styled.button`
  border: 0;
  cursor: pointer;
`;

export const SkillsContainer = styled.div``;

export const Skill = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom:  0.5px solid #CECECE;

  position: relative;

  -webkit-transition: opacity display 0.9s ease-in-out;
  -moz-transition: opacity display 0.9s ease-in-out;
  transition: opacity display 0.9s ease-in-out;
`;

export const ButtonDelete = styled.button`
  display: none;
  align-items: center;
  justify-content: center;

  opacity: 0;

  width: 3rem;
  height: 100%;

  background-color: transparent;

  border: 0;

  cursor: pointer;
  position: absolute;
  top: 50%;
  left: -16px;
  transform: translateY(-50%);



  ${Skill}:hover & {

    
    opacity: 0.9;
    display: flex;
  }
`;

export const SkillTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
`;

export const SkillTitle = styled.span`
  font-size: 1.6rem;
  line-height: 2rem;
  color: ${styleSheet.shapeDark};

  text-transform: capitalize;

  margin: 16px 0;
`;

export const SkillNiveis = styled.div`
  display: flex;
  align-items: center;
`;

export const SkillNivelCircle = styled.span`
  width: 14px;
  height: 14px;
  border-radius: 7px;

  background-color: #ccc;

  margin-right: 7px;

  cursor: pointer;
`;

export const AddProdutoContainer = styled.div`
  width: 90%;
  margin: 30px auto;

  background-color: ${styleSheet.shape};

  border-radius: 10px;
`;

export const AddProdutoHeader = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 10px 30px;

  background-color: ${styleSheet.colorMain};
  border-radius: 10px;

`;

export const Load = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
